import { cva } from 'class-variance-authority'

export const breadcrumbListStyles = cva(
  `
    gap-1.5
    sm:gap-2.5
    flex
    flex-wrap
    items-center
    break-words
    text-sm
    text-neutral-500
  `
)

export const breadcrumbItemStyles = cva(`
  inline-flex
  items-center
  gap-1.5
`)

export const breadcrumbLinkStyles = cva(`
  p-0
  transition-[background-color] duration-150 ease-in-out
  text-neutral-500
  hover:text-neutral-700
  hover:bg-transparent
`)

export const breadcrumbPageStyles = cva(`
  font-normal
  text-neutral-700
  no-underline
`)

export const breadcrumbSeparatorStyles = cva(`
  [&>svg]:w-3.5
  [&>svg]:h-3.5
`)

export const breadcrumbEllipsisStyles = cva(`
  flex
  h-9
  w-9
  items-center
  justify-center
`)
